"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.LottieHotspotAnimation = void 0;
var _lottieHotspotAnimation = _interopRequireDefault(require("./components/lottie-hotspot-animation"));
exports.LottieHotspotAnimation = _lottieHotspotAnimation["default"];